export const ReasoningService = Symbol.for('ReasoningService');
